import React from 'react';

import { Address } from 'common/api/models/Address';
import { Modal, ModalSize } from 'components/modal/Modal';
import { Btn } from 'components/btn/Btn';

export interface SuggestedAddressProps {
    suggestedAddress: Address;
    originalAddress: Address;
    onClose: () => void;
    onConfirm: (useSuggestion: boolean) => void;
}

export const SuggestedAddress = ({
    suggestedAddress,
    originalAddress,
    onConfirm,
    onClose,
}: SuggestedAddressProps) => {
    const originalStreetAddress = originalAddress.address2
        ? `${originalAddress.address1} ${originalAddress.address2}`
        : originalAddress.address1;
    const suggestedStreetAddress = suggestedAddress.address2
        ? `${suggestedAddress.address1} ${suggestedAddress.address2}`
        : suggestedAddress.address1;

    return (
        <Modal
            title="Suggested Address"
            isOpen={Boolean(suggestedAddress)}
            onClose={onClose}
            size={[ModalSize.CONTENT_WIDTH, ModalSize.CONTENT_WIDTH]}
        >
            {suggestedAddress && (
                <>
                    <p className="text-xl font-bold mb-4">
                        Would you like to update to the suggested address match?
                    </p>
                    <div>
                        <h3 className="font-bold">Original Address</h3>
                        <p>{originalStreetAddress}</p>
                        <p>
                            {originalAddress.city}, {originalAddress.state},{' '}
                            {originalAddress.zipCode}
                        </p>
                    </div>
                    <div className="mt-4">
                        <h3 className="font-bold">Suggested Address</h3>
                        <div>
                            <p>{suggestedStreetAddress}</p>
                            <p>
                                {suggestedAddress.city}, {suggestedAddress.state},{' '}
                                {suggestedAddress.zipCode}
                            </p>
                        </div>
                    </div>
                    <div className="mt-8">
                        <div className="text-center mt-4">
                            <Btn
                                type="button"
                                className="w-full mb-2 sm:max-w-xs"
                                onClick={() => onConfirm(true)}
                            >
                                Yes
                            </Btn>
                            <Btn type="button" isSecondary={true} onClick={() => onConfirm(false)}>
                                No, Use Address As Entered
                            </Btn>
                        </div>
                    </div>
                </>
            )}
        </Modal>
    );
};
